import { identity } from "lodash";

export function alphabeticalSort(a: string, b: string, desc = false): number {
  // Do not compare empty strings
  if (a.length === 0 && b.length === 0) {
    return 0;
  }

  // Move empty string at the bottom of list
  if (a.length === 0) {
    return 1;
  }

  // Move reference value at the top of the list
  if (b.length === 0) {
    return -1;
  }

  return (desc ? -1 : 1) * a.localeCompare(b);
}

export function numberSort(a: number, b: number, desc = false): number {
  if (a == null && b == null) {
    return 0;
  }

  if (a == null) {
    return 1;
  }

  if (b == null) {
    return -1;
  }

  if (a === b) {
    return 0;
  }

  return (desc ? -1 : 1) * (a > b ? 1 : -1);
}

export function dateSort(a: Date, b: Date, desc = false): number {
  if (!a && !b) {
    return 0;
  }

  if (!a) {
    return 1;
  }

  if (!b) {
    return -1;
  }

  return (desc ? -1 : 1) * (a.getTime() - b.getTime());
}

// @ts-expect-error TS(6133): 'b' is declared but its value is never read.
export function booleanSort(a: boolean, b: boolean, desc = false): number {
  return (desc ? -1 : 1) * (a ? 1 : -1);
}

/**
 * Returns a function to be used with Array's .sort()
 * @param propertySelector function which is used to extract the property that the entities should be sorted by
 */
export function alphabeticalSortBySelector<E>(
  propertySelector: (entity: E) => string = identity
): (a: E, b: E) => number {
  return (a, b) => propertySelector(a).localeCompare(propertySelector(b));
}
